import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message, Select } from 'antd';
import { oneKlicks } from '../../SDK/oneclick';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import ImageShow from '../../Uitiles/ImageShow';
import decodeHtml from '../../Uitiles/decodeHtml';

const EditServices = ({ closeModal, data, getServices }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [old_id, setOld_id] = useState(data.id);
    const [manualImage, setManualImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [specialities, setSpecialities] = useState([]);

    useEffect(() => {
        getSpecialities();
    }, []);

    useEffect(() => {
        if (data && specialities.length > 0) {
            const selectedSpeciality = specialities.find(
                s => String(s.id) === String(data.speciality_id)
            );

            form.setFieldsValue({
                name: data.name,
                color: data.color,
                speciality: selectedSpeciality ? selectedSpeciality.id : null
            });

            setOld_id(data.id);

            setImagePreview(data.url);
        }
    }, [data, specialities, form]);

    const getSpecialities = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = {};
            const orderBy = '';
            const search = '';
            const pagination = '';

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination);
            setSpecialities(response.data);
        } catch (error) {
            console.error('Error fetching specialities:', error);
            message.error('Failed to fetch specialities');
        }
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'services';

            let fileId = data.url;
            const file = manualImage;
            if (file) {
                const root = 'services';
                const status = 'publish';
                const uploadResponse = await OneKlicksFileSDK.uploadFile(root, status, file);
                fileId = uploadResponse.fileId;

                if (data.url) {
                    await OneKlicksFileSDK.deleteFile(data.url);
                }
            }

            const serviceData = {
                id: data.id,
                name: values.name,
                slug: values.name.toLowerCase().replace(/\s+/g, '-'),
                color: values.color || '',
                url: fileId,
                status: 'publish',
                speciality_id: values.speciality
            };

            const conditions = {
                id: old_id
            };

            const response = await oneKlicks.update(tableSchema, tableName, serviceData, conditions);

            if (response && response.success) {
                message.success('Service updated successfully');
                closeModal(false);
                getServices();
            } else {
                message.error('Failed to update service');
            }
        } catch (error) {
            console.error('Error updating service:', error);
            message.error('Failed to update service');
        } finally {
            setLoading(false);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/') && file.size <= 2 * 1024 * 1024) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
                setManualImage(file);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please upload a valid image (max 2MB).');
        }
    };

    return (
        <Modal
            title="Edit Service"
            open={true}
            onCancel={() => closeModal(false)}
            footer={null}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
            >
                <Form.Item
                    name="speciality"
                    label="Speciality"
                    rules={[{ required: true, message: 'Please select speciality' }]}
                >
                    <Select
                        placeholder="Select speciality"
                        options={specialities.map(speciality => ({
                            label: decodeHtml(speciality.name),
                            value: speciality.id
                        }))}
                        showSearch
                        style={{ width: '100%', height: '50px' }}
                        optionFilterProp="label"
                    />
                </Form.Item>

                <Form.Item
                    name="name"
                    label="Service Name"
                    rules={[{ required: true, message: 'Please enter service name' }]}
                >
                    <Input placeholder="Enter service name" />
                </Form.Item>

                <Form.Item
                    name="color"
                    label="Color"
                >
                    <Input type="color" />
                </Form.Item>

                <Form.Item
                    label="Service Image"
                >
                    <Input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                    {imagePreview && (
                        <div className="mt-3">
                            <img src={imagePreview} alt="Preview" className="img-thumbnail" style={{ width: '100px', height: '100px' }} />
                        </div>
                    )}
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Update Service
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditServices;
